import "./statcard.css";

export default function StatCard({
  title,
  value,
  icon,
  percent,
  iconBg,
}) {
  return (
    <div className="rp-statcard-container">
      <div className="rp-statcard-top">
        <div
          className="rp-statcard-icon"
          style={{ background: iconBg }}
        >
          {icon}
        </div>

        {percent && (
          <span className="rp-statcard-percent">+{percent}%</span>
        )}
      </div>

      <h4>{value}</h4>
      <p>{title}</p>
    </div>
  );
}
